//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            setup: {
                id: 0,
                prepaid_gl_code_id: null,
                concessions_gl_code_id: null,
                change_in_prepaid_gl_code_id: null,
                vacancy_gl_code_id: null,
                accounts_receivable_gl_code_id: null,
                accounts_payable_gl_code_id: null,
                gpr_gl_code_id: null,
                delinquent_gl_code_id: null,
                loss_to_lease_gl_code_id: null,
                retained_earnings_gl_code_id: null,
                operating_expense_gl_code_id: null,
                llc_gl_code_id: null,
                operating_gl_code_id: null,
                capital_gl_code_id: null,
                rehab_gl_code_id: null

            },
            accounts: [],
            edit: false,
            loading: true,
            empty: false
        };
    },


    methods: {
        startEdit: function startEdit() {
            this.edit = true;
            this.empty = false;
            this.accountNames.push({ id: 0, label: "Not selected..." });
        },
        save: function save() {
            var $el = this;
            $el.loading = true;

            axios.post('/prototype/accounting/general-ledger/settings/gl-setup/update', $el.setup).then(function (response) {
                $el.edit = false;
                $el.loading = false;
            });
        },
        refreshGLSettings: function refreshGLSettings() {
            var $el = this;

            axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                $el.accounts = response.data;
            }).then(function () {
                axios.post('/prototype/accounting/general-ledger/settings/gl-setup/fetch').then(function (response) {
                    if (response.data != '') {
                        $el.setup = response.data;
                    } else {
                        $el.empty = true;
                    }
                    $el.loading = false;
                });
            });
        }
    },

    created: function created() {
        var $el = this;
        Event.$on('refresh-gl-settings', this.refreshGLSettings);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-gl-settings');
    },

    computed: {
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/settings/GlSetup.vue
// module id = zSYa
// module chunks = 0 1